const WidgetsData = [
    {
        id: 1,
        title: "Bugünkü Toplam Tahsilat",
        price: 125.8,
        rank: "+₺15.2k",
        isDoller: false,
        postFix: "k ₺",
        statusColor: "success",
        series: [2, 10, 18, 22, 36, 15, 47, 75, 65, 19, 14, 2, 47, 42, 15],
    },
    {
        id: 2,
        title: "Bu Ayki İşlem Sayısı",
        price: 1847,
        rank: "+142 İşlem",
        isDoller: false,
        statusColor: "success",
        series: [15, 42, 47, 2, 14, 19, 65, 75, 47, 15, 42, 47, 2, 14, 12,]
    },
    {
        id: 3,
        title: "Aylık Ortalama Tutar",
        price: 43.2,
        rank: "+₺8.5k",
        isDoller: false,
        postFix: "k ₺",
        statusColor: "success",
        series: [47, 15, 2, 67, 22, 20, 36, 60, 60, 30, 50, 11, 12, 3, 8,]
    },
    {
        id: 4,
        title: "Başarılı Ödeme Oranı",
        price: 94.7,
        rank: "+%2.1",
        isDoller: false,
        postFix: "%",
        statusColor: "success",
        series: [12, 14, 2, 47, 42, 15, 47, 75, 65, 19, 14, 2, 47, 42, 15,]
    },
];

// Kur ve Emtia Verileri
const CurrencyData = [
    {
        id: 1,
        title: "USD/TRY",
        price: 34.15,
        change: "+0.08",
        changePercent: "+0.23%",
        statusColor: "success",
        series: [34.07, 34.12, 34.09, 34.15, 34.18, 34.16, 34.15, 34.11, 34.15, 34.18, 34.20, 34.15],
    },
    {
        id: 2,
        title: "EUR/TRY",
        price: 37.42,
        change: "-0.15",
        changePercent: "-0.40%",
        statusColor: "danger",
        series: [37.57, 37.55, 37.48, 37.42, 37.39, 37.44, 37.42, 37.40, 37.42, 37.38, 37.35, 37.42],
    },
    {
        id: 3,
        title: "Altın (Gram)",
        price: 2847.50,
        change: "+12.30",
        changePercent: "+0.43%",
        statusColor: "success",
        series: [2835.20, 2838.40, 2842.10, 2847.50, 2845.80, 2847.50, 2850.20, 2847.50, 2849.10, 2847.50, 2851.20, 2847.50],
    },
    {
        id: 4,
        title: "Gümüş (Gram)",
        price: 34.82,
        change: "-0.25",
        changePercent: "-0.71%",
        statusColor: "danger",
        series: [35.07, 35.02, 34.95, 34.82, 34.78, 34.85, 34.82, 34.80, 34.82, 34.75, 34.70, 34.82],
    },
];

// Aylık Tahsilat Verileri
const MarketOverViewAllData = [
    {
        name: "Tahsilat",
        data: [
            125.45, 156.2, 98.9, 134.42, 142.6, 168.1, 178.2, 164.16, 151.1, 128.09, 176.34,
            142.88,
        ],
    },
    {
        name: "İptal",
        data: [
            -11.45, -15.42, -7.9, -12.42, -12.6, -18.1, -18.2, -14.16, -11.1, -7.09,
            -15.34, -11.88,
        ],
    },
];

const MarketOver1MData = [
    {
        name: "Tahsilat",
        data: [
            144.45, 130.2, 118.9, 154.42, 136.6, 148.1, 158.2, 148.16, 141.1, 138.09, 146.34,
            142.88,
        ],
    },
    {
        name: "İptal",
        data: [
            -8.45, -12.42, -9.9, -10.42, -11.6, -9.1, -13.2, -12.16, -10.1, -8.09,
            -12.34, -14.88,
        ],
    },
];

const MarketOver6MData = [
    {
        name: "Tahsilat",
        data: [
            142.45, 164.2, 128.9, 141.42, 152.6, 178.1, 162.2, 154.16, 161.1, 148.09, 166.34,
            158.88,
        ],
    },
    {
        name: "İptal",
        data: [
            -13.45, -17.42, -19.9, -14.42, -15.6, -12.1, -20.2, -16.16, -3.1, -9.09,
            -7.34, -13.88,
        ],
    },
];

const MarketOver1YData = [
    {
        name: "Tahsilat",
        data: [
            112.45, 136.2, 148.9, 131.42, 142.6, 158.1, 138.2, 154.16, 141.1, 168.09, 156.34,
            142.88,
        ],
    },
    {
        name: "İptal",
        data: [
            -13.45, -8.42, -9.9, -14.42, -4.6, -20.1, -19.2, -6.16, -12.1, -8.09,
            -17.34, -3.88,
        ],
    },
];

// Ödeme Yöntemi Dağılımı
const PieChart1YData = [65, 25, 10]; // Kredi Kartı, Banka Kartı, Diğer

const PieChart6MData = [70, 20, 10];

const PieChart1MData = [75, 15, 10];

const PieChartAllData = [68, 22, 10];

// Haftalık Performans
const InvestedOverviewMay = [85];
const InvestedOverviewApril = [72];
const InvestedOverviewMarch = [68];
const InvestedOverviewFeb = [91];
const InvestedOverviewJan = [76];
const InvestedOverviewDec = [83];

// Saat Bazlı İşlem Yoğunluğu
const HourlyTransactionData = [
    { hour: '00:00', transactions: 5 },
    { hour: '01:00', transactions: 3 },
    { hour: '02:00', transactions: 2 },
    { hour: '03:00', transactions: 1 },
    { hour: '04:00', transactions: 2 },
    { hour: '05:00', transactions: 8 },
    { hour: '06:00', transactions: 15 },
    { hour: '07:00', transactions: 28 },
    { hour: '08:00', transactions: 45 },
    { hour: '09:00', transactions: 67 },
    { hour: '10:00', transactions: 89 },
    { hour: '11:00', transactions: 92 },
    { hour: '12:00', transactions: 78 },
    { hour: '13:00', transactions: 85 },
    { hour: '14:00', transactions: 95 },
    { hour: '15:00', transactions: 88 },
    { hour: '16:00', transactions: 76 },
    { hour: '17:00', transactions: 82 },
    { hour: '18:00', transactions: 69 },
    { hour: '19:00', transactions: 54 },
    { hour: '20:00', transactions: 42 },
    { hour: '21:00', transactions: 35 },
    { hour: '22:00', transactions: 28 },
    { hour: '23:00', transactions: 18 },
];

// Şehir Bazlı İşlem Dağılımı
const CityTransactionData = [
    { city: 'İstanbul', percentage: 28.5, transactions: 2847 },
    { city: 'Ankara', percentage: 15.2, transactions: 1521 },
    { city: 'İzmir', percentage: 12.8, transactions: 1284 },
    { city: 'Bursa', percentage: 8.7, transactions: 873 },
    { city: 'Antalya', percentage: 7.3, transactions: 732 },
    { city: 'Adana', percentage: 5.9, transactions: 594 },
    { city: 'Konya', percentage: 4.8, transactions: 485 },
    { city: 'Gaziantep', percentage: 4.2, transactions: 421 },
    { city: 'Diğer', percentage: 12.6, transactions: 1264 },
];

// Son İşlemler Mock Data
const RecentTransactionsData = [
    {
        id: 'TXN-2025-001',
        amount: 1250.00,
        currency: 'TRY',
        method: 'Kredi Kartı',
        status: 'Başarılı',
        customer: 'Mehmet Yılmaz',
        date: '2025-07-01 14:35:22',
        statusColor: 'success'
    },
    {
        id: 'TXN-2025-002',
        amount: 875.50,
        currency: 'TRY',
        method: 'Banka Kartı',
        status: 'Başarılı',
        customer: 'Ayşe Kaya',
        date: '2025-07-01 14:32:15',
        statusColor: 'success'
    },
    {
        id: 'TXN-2025-003',
        amount: 2340.75,
        currency: 'TRY',
        method: 'Kredi Kartı',
        status: 'Beklemede',
        customer: 'Ali Demir',
        date: '2025-07-01 14:28:45',
        statusColor: 'warning'
    },
    {
        id: 'TXN-2025-004',
        amount: 495.25,
        currency: 'TRY',
        method: 'Banka Kartı',
        status: 'İptal',
        customer: 'Fatma Özkan',
        date: '2025-07-01 14:25:12',
        statusColor: 'danger'
    },
    {
        id: 'TXN-2025-005',
        amount: 1680.00,
        currency: 'TRY',
        method: 'Kredi Kartı',
        status: 'Başarılı',
        customer: 'Hasan Çelik',
        date: '2025-07-01 14:22:38',
        statusColor: 'success'
    },
];

export {
    WidgetsData,
    CurrencyData,
    MarketOver1YData,
    MarketOver6MData,
    MarketOver1MData,
    MarketOverViewAllData,
    PieChart1YData,
    PieChart6MData,
    PieChart1MData,
    PieChartAllData,
    InvestedOverviewMay,
    InvestedOverviewApril,
    InvestedOverviewMarch,
    InvestedOverviewFeb,
    InvestedOverviewJan,
    InvestedOverviewDec,
    HourlyTransactionData,
    CityTransactionData,
    RecentTransactionsData
};